import React from 'react';
import Script from 'react-load-script';

const TileImport = (props) => {
  const {
    id, importFile, addDiv, organization,
  } = props;

  const handleScriptError = () => {
    if (process.env.REACT_APP_ENVIRONMENT !== 'production') {
      console.log(`Error while loading script: ${id}`);
    }
  };

  const handleScriptLoad = () => {
    if (process.env.REACT_APP_ENVIRONMENT !== 'production') {
      console.log(`Script loaded successfully: ${id}`);
    }
  };

  const addScipt = () => {
    return (addDiv || document.getElementsByTagName(id).length > 0 ? (<Script
      url={`${importFile}`}
      onError={() => handleScriptError()}
      onLoad={() => handleScriptLoad()}
    />) : (<></>));
  };

  return (
    <>
      {addDiv && <div dangerouslySetInnerHTML={{ __html: `<${id} organization="${organization}"></${id}>` }} />}
      {addScipt()}
    </>
  );
};

export default TileImport;
